import { Box, Text, Stack } from "@chakra-ui/react";
import { ReactNode } from "react";

interface NavSectionProps {
  title: string;
  children: ReactNode;
}

export function NavSection({ title, children }: NavSectionProps) {
  return (
    <Box>
      <Stack spacing="0">
        {children}
      </Stack>
    </Box>
  );
}
